export default __webpack_public_path__ + "static/media/zarate.27a3d3da.jpg";